import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { Tabs } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Tab
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/Tabs/Tab';

const styles = (theme) => ({
  root: {
    minWidth: 0,
  },
  tabs: {
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: theme.palette.facet.accentBlue,
    },
  },
  tabRoot: {
    width: 160,
    minWidth: 110,
  },
});

const FacetTabs = ({
  className,
  classes,
  tabs,
  onChange,
  variant,
  value,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Tabs
        className={classes.tabs}
        value={value}
        indicatorColor={'primary'}
        textColor={'primary'}
        onChange={onChange}
        variant={variant}
        scrollButtons={variant === 'scrollable' ? 'on' : 'off'}
        TabIndicatorProps={{ children: <span /> }}
        scrollable
      >
        {tabs.map(tab => {
          return !tab.isHidden && (
            <Tab
              key={tab.key}
              value={tab.value}
              label={tab.label}
              disabled={tab.disabled}
              classes={{
                root: classes.tabRoot,
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

FacetTabs.defaultProps = {
  className: '',
  variant: 'scrollable',
  value: null,
};

FacetTabs.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  classes: PropTypes.object.isRequired,
  tabs: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default withStyles(styles)(FacetTabs);
